import { FC, useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { download_icon } from 'src/assets'
import { shoot } from 'src/redux/actions'
import { select_document, select_public_documents } from 'src/redux/store/data/selectors'
import { document_t } from 'src/types'
import { download_blob, render_topbar, to_blob } from 'src/utils'
import { Button } from 'src/widgets'

interface acc_privacy_t {
  text: string;
  link_label: string;
  link_url: string;
}

interface accessibility_item {
  title: string;
  text: string;
  list?: string[];
  privacies: acc_privacy_t[];
}

interface document_item {
  title?: string;
  download?: string;
}

interface accessibility_t {
  items: accessibility_item[];
  document_section: document_item;
}

const Accessibilita: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  /**
   * Use State
   */
  const [action, set_action] = useState('')

  /**
   * Use Selectors
   */
  const documents = useSelector(select_public_documents)
  const document = useSelector(select_document)

  /**
   * Effects
   */
  useEffect(() => {
    if (!documents) {
      dispatch(shoot.saga_resolve_public_documents({ domain: 'ACC', subdomain: 'DAC' }))
    }
  }, [])

  useEffect(() => {
    if (document) {
      if (action === 'download') {
        download_blob(to_blob(document?.pdf || ''), document?.name)
        set_action('')
      }
    }
  }, [document])

  /**
   * Render functions
   */
  const render_doc = (doc: document_t, idx: number) => (
    <div key={idx} className="d-flex justify-content-between pt-5 pb-3 border-bottom font-15-semibold">
      <p>{doc?.documentDescription}</p>

      <Button
        text={accessibility_data?.document_section?.download}
        flavor="transparent_primary_next"
        classes="p-0"
        iconr={download_icon}
        on_press={() => {
          download_document(doc.documentValue || '', 'ACC', 'DAC')
        }}
      />
    </div>
  )

  const download_document = (documentValue: string, domain: string, subdomain: string) => {
    dispatch(
      shoot.saga_download_public_document({
        documentValue,
        domain,
        subdomain,
      })
    )
    set_action('download')
  }

  const accessibility_data: accessibility_t = t('accessibility', { returnObjects: true })

  return (
    <Container fluid className="mb-5 pb-5 d-flex justify-content-center bg-f7f7f7">
      <Col lg={11}>
        {/* TOP-BAR */}
        {render_topbar(() => navigate(-1), t('commons.back'))}

        {/* MAIN SECTION */}
        <Row className="d-flex justify-content-center">
          <Col md={10}>
            {accessibility_data?.items?.map((item: accessibility_item, index: number) => (
              <div key={index} className="my-4">
                {item?.title && <div className="font-16-semibold c-862633 mb-4">{item?.title}</div>}
                {item?.text && <div dangerouslySetInnerHTML={{ __html: item?.text || '' }} />}
                {item?.list && (
                  <ul>
                    {item?.list?.map((x: string, index: number) => (
                      <li key={index} className="my-2">
                        <span className="ml-2">{x}</span>
                      </li>
                    ))}
                  </ul>
                )}
                {item?.privacies?.map((privacy: acc_privacy_t, index: number) => (
                     <span key={index}>
                     <span dangerouslySetInnerHTML={{ __html: privacy?.text || '' }} />
                     <a href={privacy?.link_url} target="_blank" rel="noreferrer">{privacy?.link_label}</a>
                   </span>
                  ))}
              </div>
            ))}
          </Col>
        </Row>

        {/* DOCUMENT SECTION */}
        <Row className="mt-4 d-flex justify-content-center font-30-semibold text-uppercase text-center">
          <Col className="col-xl-8 col-12">
            <p className="font-30-semibold">
              {accessibility_data?.document_section.title}
            </p>
            <div className="mt-4 d-flex justify-content-md-center align-items-center">
              <div className="col-12 col-md-8">

              {documents?.map((doc: document_t, idx: number) => render_doc(doc, idx))}

              </div>

            </div>
          </Col>
        </Row>
      </Col>
    </Container>
  )
}

export default Accessibilita
